import React from "react";
import PropTypes from "prop-types";
import { useStores } from "../../store";
import { FaUser, FaList, FaExternalLinkAlt } from "react-icons/fa"; // Import new icons
import { AiOutlineExport } from "react-icons/ai";
import { FaSliders } from "react-icons/fa6";

const TableLoading = ({
  numRows,
  rowHeight,
  bgColor,
  headerTitles,
  rowBoxes,
  showProfilePic,
  page,
}) => {
  const { RecuiterStore } = useStores();

  // Define dynamic header titles based on the page
  const dynamicHeaderTitles =
    page === "resumescore"
      ? [
          { name: "Name", width: "16%", paddingLeft: "0" },
          { name: "Mail", width: "21%", paddingLeft: "0" },
          { name: "Experience", width: "16%", paddingLeft: "0" },
          { name: "Score", width: "16%", paddingLeft: "0px" },
          { name: "Suggestion", width: "11%", paddingLeft: "0px" },
          { name: "Resume", width: "10%", paddingLeft: "0" },
        ]
      : page === "Interview"
      ? [
          { name: "Name", width: "16%", paddingLeft: "0" },
          { name: "Mail", width: "21%", paddingLeft: "0" },
          { name: "Test Date", width: "16%", paddingLeft: "0" },
          { name: "Overall Score", width: "16%", paddingLeft: "0px" },
          { name: "Labels", width: "11%", paddingLeft: "0px" },
          { name: "Report", width: "10%", paddingLeft: "0" },
        ]
      : page === "MCQ Tests" || page === "Applicants"
      ? [
          { name: "Name", width: "16%", paddingLeft: "0" },
          { name: "Mail", width: "21%", paddingLeft: "0" },
          { name: "Role", width: "16%", paddingLeft: "0" },
          { name: "Test Name", width: "16%", paddingLeft: "0px" },
          { name: "Labels", width: "11%", paddingLeft: "0px" },
          { name: "Report", width: "10%", paddingLeft: "0" },
        ]
      : page === "Jobposts"
      ? [
          { name: "Job Title", width: "15%" },
          { name: "Company Name", width: "20%" },
          { name: "Salary", width: "15%" },
          { name: "Experience", width: "15%" },
          { name: "Location", width: "10%" },
          { name: "Work Mode", width: "10%" },
          { name: "Labels", width: "15%" },
        ]
      : headerTitles;

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-orange-500">
          Recent applicants
        </h2>
        <div className="flex items-center text-orange-500 space-x-2">
          <button>
            <FaSliders />
          </button>
          <button>
            <AiOutlineExport />
          </button>
        </div>
      </div>

      {RecuiterStore.loader ? (
        <>
          <div className="w-full p-5 md:mt-0 hidden md:block">
            {/* Header with actual titles */}
            <div className="flex items-center bg-[#FFE9D9] py-3 px-5 rounded-lg shadow-md justify-around text-center animate-pulse">
              {dynamicHeaderTitles.map((title, idx) => (
                <div
                  key={idx}
                  className="text-sm font-medium text-gray-600 mx-2"
                  style={{
                    width: title.width,
                    paddingLeft: title.paddingLeft,
                  }}
                >
                  {title.name}
                </div>
              ))}
            </div>

            {/* Rows loading effect */}
            <div className="mt-5 space-y-4">
              {Array.from({ length: numRows }).map((_, index) => (
                <div
                  key={index}
                  className={`${bgColor} flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                  style={{ height: rowHeight }}
                >
                  {showProfilePic && page !== "resumescore" && (
                    <div
                      className="rounded-full bg-gray-300 animate-pulse"
                      style={{ width: "3rem", height: "3rem" }}
                    ></div>
                  )}

                  <div
                    className={`flex-1 ${
                      showProfilePic && page !== "resumescore" ? "ml-4" : ""
                    } flex w-full justify-around`}
                  >
                    {rowBoxes.map((rowBox, idx) => (
                      <div
                        key={idx}
                        className={`bg-gray-300 ${
                          rowBox.shape === "rectangle"
                            ? "rounded-md"
                            : "rounded-full"
                        } mx-2 animate-pulse`}
                        style={{ width: rowBox.width, height: rowBox.height }}
                      ></div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="md:hidden lg:hidden bg-white p-4 mb-3 h-[15%] flex-wrap rounded-lg shadow-lg flex flex-col gap-0 animate-pulse">
            <div className="flex flex-row w-full text-xs justify-between items-center">
              <div className="flex items-center gap-4">
                <h1 className="md:hidden lg:hidden mr-0 pt-0 pl-0 p-3 w-[20%] ">
                  <div className="w-12 flex h-12 mt-2  items-center justify-center rounded-full bg-gray-200 animate-pulse">
                    <FaUser className="text-gray-400 " />
                  </div>
                </h1>
                <div className="w-32 truncate">
                  <h1 className=" animate-pulse w-40 mb-2 bg-gray-400 h-3">
                    {"" || "-"}
                  </h1>{" "}
                  <h1 className=" animate-pulse w-40 bg-gray-400 h-3">
                    {"" || "-"}
                    <span>
                      {/* {applicant?.email ? `${applicant?.mail}%` : "-"} */}
                    </span>
                  </h1>
                </div>
              </div>
              <h1 className="ml-4">
                <span className="px-3 py-2 w-40 bg-gray-400 h-3  rounded-md text-white text-[10px] whitespace-nowrap animate-pulse">
                  {""}
                </span>
              </h1>
            </div>
            <div className="flex mr-4 text-xs gap-4 whitespace-nowrap">
              <h1 className="animate-pulse w-40 bg-gray-400 h-5">
                <span className="text-slate-500"></span>
                {""}
              </h1>

              <h1 className="animate-pulse w-40 bg-gray-400 h-5">
                <span className="text-slate-500"></span>
                {""}
              </h1>
            </div>
            <div className="flex justify-between w-full items-center">
              <h1 className="p-4 animate-pulse w-20 bg-gray-400 h-5">{""}</h1>

              <h1 className="p-4 animate-pulse w-20 bg-gray-400 h-5">{""}</h1>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

TableLoading.propTypes = {
  numRows: PropTypes.number,
  rowHeight: PropTypes.string,
  bgColor: PropTypes.string,
  headerTitles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
    })
  ),
  rowBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
      shape: PropTypes.oneOf(["circle", "rectangle"]),
    })
  ),
  showProfilePic: PropTypes.bool,
  page: PropTypes.string,
};

TableLoading.defaultProps = {
  numRows: 5,
  rowHeight: "4rem",
  bgColor: "bg-gray-100",
  showProfilePic: true,
  page: "",
  headerTitles: [
    { name: "Profile pic", width: "5%" },
    { name: "Name", width: "15%" },
    { name: "Email ID", width: "20%" },
    { name: "Applied date", width: "15%" },
    { name: "Applied for", width: "15%" },
    { name: "Total Score", width: "10%" },
    { name: "Status", width: "10%" },
  ],
  rowBoxes: [
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "20%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%",
      height: "1.2rem",
      shape: "rectangle",
    },
  ],
};

export default TableLoading;
